import type { TestFunction } from 'yup';

import { FieldErrors } from 'shared/lib/fields';

export const differentFromFields =
  (fields: string | string[], message?: string): TestFunction =>
  (value, context) => {
    const fieldValues = ([] as string[]).concat(fields).map((field) => context.parent[field]);
    const normalizedValue = ((value as string) || '').replace(/\D/g, '');

    const isValid =
      !normalizedValue ||
      fieldValues.every((fieldValue) => normalizedValue !== ((fieldValue as string) || '').replace(/\D/g, ''));

    return (
      isValid ||
      context.createError({
        path: context.path,
        message: message || FieldErrors.valuesAreEqual,
      })
    );
  };
